import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import ServiceListPage from './pages/ServiceListPage';
import ShopListPage from './pages/ShopListPage';
import ShopDetailPage from './pages/ShopDetailPage';
import BookAppointmentPage from './pages/BookAppointmentPage';
import Footer from './components/Footer'; // Import the Footer component

/**
 * Main App Component
 * Handles routing for the application.
 * @returns {JSX.Element}
 */
const App = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen"> {/* Added a flex container for layout */}
        <div className="flex-grow"> {/* Content area that grows */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/services/:categoryId" element={<ServiceListPage />} />
            <Route path="/shops/:categoryId" element={<ShopListPage />} />
            <Route path="/shop/:shopId" element={<ShopDetailPage />} />
            <Route path="/book/:shopId" element={<BookAppointmentPage />} />
            <Route path="/bookings" element={<BookAppointmentPage />} />
          </Routes>
        </div>
        <Footer /> {/* Render the Footer component */}
      </div>
    </Router>
  );
};

export default App;
